import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Card } from "./card";

const cardsData = [
  {
    icon: "assets/images/kwikcheckoutcod/instant-login.svg",
    headline: "Instant login & verification",
    cta: "20% reduction in drop-offs & 60% faster login to address",
    details: [
      "One-click login via phone, OTP, Truecaller & WhatsApp",
      "Auto-login via SSO keeps returning shoppers signed in",
      "Effortless verification with frictionless authentication",
    ],
  },
  {
    icon: "assets/images/kwikcheckoutcod/smart-address.svg",
    headline: "Smart address autofill",
    cta: "Reduce drop-offs by 50% at this stage",
    details: [
      "Prefill up to 85% of addresses with our 120M+ shopper database",
      "Show the most recent address as default",
      "Smart suggestions reduce new address fields by 50%",
    ],
  },
  {
    icon: "assets/images/kwikcheckoutcod/boosting-discount.svg",
    headline: "Revenue-boosting discounts & offers",
    cta: "Improve conversion rate by 25-30%",
    details: [
      "Access 250+ dynamic ecommerce discounts",
      "Industry-first all-prepaid payment discounts",
      "Leverage exclusive loyalty & rewards partnerships",
    ],
  },
  {
    icon: "assets/images/kwikcheckoutcod/frictionless-payment.svg",
    headline: "Frictionless payment experience",
    cta: "Highest pre-paid success rate & 100% payment assurance",
    details: [
      "Accept UPI, cards, wallets, net banking, pay later & smart COD",
      "Auto-switch gateways for the highest prepaid success rate",
      "Convert failed prepaid payments into COD",
    ],
  },
  {
    icon: "assets/images/kwikcheckoutcod/cod-and-rto.svg",
    headline: "COD & RTO intelligence",
    cta: "Reduce RTO by 40%",
    details: [
      "Offer/hide COD on checkout",
      "Verify buying intent using COD OTP, Captcha, fees, etc",
      "Leverage partial COD to get part payment upfront & the rest on delivery",
    ],
  },
  {
    icon: "assets/images/kwikcheckoutcod/safe-and-secure.svg",
    headline: "Safe & Secure Checkout experience",
    cta: "Customer trust that is immeasurable",
    details: [
      "PCI DSS Compliant",
      "ISO 29147:2018 standard for vulnerability disclosure",
      "All stored data is anonymised via masking",
      "GoKwik does not collect any financially sensitive data like UPI VPAs due to our seamless flow",
    ],
  },
];

export const SectionTwo = () => {
  const scrollToTop = () => {
    const isMobileOrTablet = window.innerWidth <= 991;
    window.scrollTo({
      top: isMobileOrTablet ? 350 : 100,
      behavior: "smooth",
    });
  };

  return (
    <div className="section-2">
      <div className="container-fluid">
        <div className="top-text">
          <h1>Kwik Checkout—o﻿ne-click checkout that converts</h1>
          <p>
            The most convenient & secure checkout experience for your shoppers
          </p>
        </div>
      </div>
      <div className="cards-container">
        {cardsData.map((data, index) => (
          <Card data={data} key={index} />
        ))}
      </div>
      <div className="container-fluid fourth d-flex justify-content-center align-items-center">
        <div className="top-text text-center">
          <div className="btn">
            <button className="cta" onClick={scrollToTop}>
              Book a Demo
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
